export const FaqData = [
  {
    id: 1,
    question: "What is Setu?",
    answer:
      "Setu meaning “bridge” is essentially a platform that helps creators port their content libraries from Twitter to DeSo. Creators can opt for syncing their past content and they can also opt for syncing all of their future content as well with our newly introduced subscription feature which is also free.",
  },
  {
    id: 2,
    question: "Why Setu?",
    answer:
      "Setu is a free service that helps creators launch into Web 3.0 Port your content from Web 2.0 to decentralized social media seamlessly. With setu you can not only sync all of your past content from twitter to deso with our sync past tweets features but you can also sync all future tweets by subscribing to setu for free. ",
  },
  {
    id: 3,
    question: "How to subscribe and shift tweets in real time?",
    answer: ` You can sync your past tweets for free and have them ported to DeSo in real-time! <br/><br/> Simply go to <span className="font-bold text-black"> our website > Click “Start Shifting Now” > Login with DeSo and Twitter > Select “Sync Past Tweets”, </span> filter your selection and <span className="font-bold text-black"> click “Sync Content” </span>`,
  },
  {
    id: 4,
    question: "How to shift your past tweets with Setu?",
    answer: `You can subscribe to Setu for free and have your Twitter content ported to DeSo in real-time! <br/><br/>
      Simply go to <span className="font-bold text-black">our website> Click “Start Shifting Now” > Login with DeSo & Twitter > Select “Real Time Sync”</span> and click “Subscribe” <br />`,
  },
  {
    id: 5,
    question: "Which multimedia does Setu support?",
    answer:
      "At the moment Setu supports text and image-based content on Twitter. However, we plan to expand this service across other multimedia and Web 2.0 platforms as well, stay tuned! ",
  },
];

export const FaqData2 = [
  {
    id: 6,
    question: "What is DeSo?",
    answer: ` DeSo is the first layer 1 blockchain custom-built to power and scale decentralized social applications.
    <br />
    <br />
    Because social applications have very different storage and scaling requirements than DeFi applications, DeSo is uniquely positioned to disrupt the trillion-dollar social media category for the first time, in a way no other blockchain is currently capable of.      DeSo is the first layer 1 blockchain custom-built to power and scale decentralized social applications.`,
  },
  {
    id: 7,
    question: "How to get involved with DeSo?",
    answer: `


    1) Buy $DESO coin 
    <br />
    2) As a creator, try a DeSo app (Check out <a target="_blank" href="https://bithunt.com/" className="text-blue">Bithunt</a>)
    <br />
    3) As a consumer, use DeSo as an end user (Check out <a  target="_blank" href="https://desocialworld.com/" className="text-blue"> DeSocialWorld</a>)
    <br />
    4) As a developer, build an app on <a target="_blank" href="https://docs.deso.org/code/dev-setup
    "  className="text-blue">DeSo</a>
    <br />
    5) Be an advocate by responding to messages on Discord and promoting our content on social channels.
`,
  },

  {
    id: 8,
    question: "How to earn money on DeSo?",
    answer: `Here we look at the key features of a decentralized social media protocol called the DeSo protocol:
    <br />
    <br />
      <span className="font-bold">Creator Coins</span>
    <br />
    <span className="font-bold">Social Tipping</span>
    <br />
    <span className="font-bold"> Social NFTs</span>
    <br />
    <br />

    You can read them more on our <a target="_blank" href="https://setu-deso.web.app/blogs/0" className="text-blue">blog</a>
    `,
  },
  {
    id: 9,
    question: "How to get help and support from Team Setu?",
    answer: `For help and support please connect with Team Setu on <a target="_blank" href="https://discord.com/invite/M9njr5cBBT" className="text-blue"> discord </a>`,
  },
  {
    id: 10,
    question: "How to invest in Setu?",
    answer: `There are multiple ways to invest in Setu <br />
    <ul className="list-disc px-4">
      <li> Invest in our <a target="_blank" href="https://daodao.io/d/setu_deso?invite=DTxqxTHX" className="text-blue">DAO </a> <br />
      </li>
      <li>
      Invest in our <a target="_blank" href="https://desocialworld.com/u/setu_deso?tab=posts" className="text-blue"> creator coin </a>  
      </li>
    </ul>
    <br />
    You can also support us by investing your time: <br />
    <ul className="list-disc px-4">
    <li> 
    Subscribe to  <a target="_blank" href="https://setu-deso.web.app/" className="text-blue"> Setu </a>   <br />
    </li>
    <li> 
    Join our <a target="_blank" href="https://discord.gg/M9njr5cBBT" className="text-blue"> discord </a>  <br />
    </li>
    <li>
    Follow us on  <a target="_blank" href="https://desocialworld.com/u/setu_deso" className="text-blue"> DeSo  </a> and <a target="_blank" href="https://twitter.com/Setuforcreators" className="text-blue">  Twitter        </li>
    </ul> </a>`,
  },
];

export const HomepageFaqData = [
  {
    id: 1,
    question: "Why Setu?",
    answer:
      "Setu is a free service that helps creators launch into Web 3.0 Port your content from Web 2.0 to decentralized social media seamlessly. With setu you can not only sync all of your past content from twitter to deso with our sync past tweets features but you can also sync all future tweets by subscribing to setu for free. ",
  },
  {
    id: 2,
    question: "How to subscribe and shift tweets in real time?",
    answer: ` You can sync your past tweets for free and have them ported to DeSo in real-time! <br/><br/> Simply go to <span className="font-bold text-black"> our website > Click “Start Shifting Now” > Login with DeSo and Twitter > Select “Sync Past Tweets”, </span> filter your selection and <span className="font-bold text-black"> click “Sync Content” </span>`,
  },
];
export const HomepageFaqData2 = [
  {
    id: 3,
    question: "Which multimedia does Setu support?",
    answer:
      "At the moment Setu supports text and image-based content on Twitter. However, we plan to expand this service across other multimedia and Web 2.0 platforms as well, stay tuned! ",
  },
  {
    id: 4,
    question: "How to shift your past tweets with Setu?",
    answer: `You can subscribe to Setu for free and have your Twitter content ported to DeSo in real-time! <br/><br/>
      Simply go to <span className="font-bold text-black">our website> Click “Start Shifting Now” > Login with DeSo & Twitter > Select “Real Time Sync”</span> and click “Subscribe” <br />`,
  },
];
